import {initTrustbars} from "../../../default/global/js/trustbar";
import {getChildrenClassForNestedItems} from "../../../default/global/js/nav";
import {closeFilterBox, initFilter} from "../../../default/global/js/filter";
import {initActionClicks, initFormSubmitChanges, initFormSubmitClicks} from "../../../default/global/js/actionClick";
import {focusInputGroups} from "./default/checkInputGroups";
import {triggerFavoritesBtns} from "./custom/favorites";
import {initQuantitySpinners} from "../../../default/global/js/quantitySpinner";
import hoverintent from "../../../default/global/js/hoverintent";
import {initSlideshows} from "./custom/slideshow";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";
import {stickyBox} from "../../../default/global/js/stickyBox.js";
import {buildMobileMenu, hideMobileMenu, showMobileMenu} from "./default/mobilemenu";
import {
    excludeModal,
    triggerConfirmModalLink,
    triggerModal,
    triggerOpenLinkInModal,
    triggerOpenTextInModal
} from "../../../default/global/js/modal";
import {triggerBasketBtns, triggerUpdateBasketView} from "./default/basket";
import {initToggleSlide} from "../../../default/global/js/toggle";
import {initItemlistSlider} from "./default/itemListSlider";
import {initScrollbars} from "../../../default/global/js/scrollbar";
import {isTouchDevice} from "../../../default/global/js/touchDevice";
import {
    hideAllCustomSelect,
    hideCustomSelect,
    initCustomSelects,
    updateCustomSelectRangeFilterAction
} from "../../../default/global/js/customSelect";
import {initJumpmarks} from "../../../default/global/js/jumpmark";
import {initSearchItems} from "../../../default/global/js/searchItems";
import {trimInputValues} from "../../../default/global/js/formValidator";
import {addLoadingClassAfterSubmit} from "../../../default/global/js/utilities/updateClasses";
import {initPasswordFields} from "../../../default/global/js/password";
import {lottieLoader} from "../../../default/global/js/lottieLoader";
import {initSlidecontents} from "../../../default/global/js/slidecontent";
import {initFlashmessages} from "../../../default/global/js/flashmessages";
import {addTableWrapper} from "../../../default/global/js/tableWrapper";
import {initPhoneCountryFields} from "../../../default/global/js/phoneCountryField";
import {initInputBody} from "../../../default/global/js/inputfile";
import initDcOrder from "../../../default/global/js/dcorder";
import {initShowMoreRatings} from "../../../default/global/js/rating";
import {initImageGallery} from "./custom/imageGallery";
import {initInputMaskDate} from "../../../default/global/js/inputMaskDate";
import {initRecaptchaForms} from "../../../default/global/js/recaptchaForm";
import {initAjaxCollectionFilter} from "../../../default/global/js/ajaxCollectionFilter";
import {initDatepicker} from "../../../default/global/js/datepicker";
import {initContentTabs} from "../../../default/global/js/contentTabs";
import {initHistorySlider} from "../../../default/global/js/history";
import {initAjaxFormApi} from "../../../default/global/js/ajaxFormApi";
import {initScrollActivate} from "../../../default/global/js/scrollactivate";
import {initRangeslider} from "./default/rangeSlider";
import {initFlyout} from "../../../default/global/js/flyoutMenu";
import {initHighlightEditors} from "../../../default/global/ts/highlightEditor";
import {maxHeightContent} from "../../../default/global/js/maxHeightContent";
import {langSwitchByHrefLang} from "../../../default/global/js/langSwitchByHrefLang";
import {switchImgOnHover} from "../../../default/global/js/switchImgOnHover";
import {changeQuantityDirectOrder, initDirectOrder} from "./default/directOrder";
import {updateItemlistStickyOrderBarCount} from "../../../default/global/js/itemlistStickyOrderBar";
import {initFunding} from "./custom/funding";
import {initLoginTabs} from "./default/loginTabs";
import {initNews} from "./custom/news";
import {initFixedContact} from "./custom/fixedContact";
import {initIOSCursorFix} from "./custom/cursorfix";

window.addEventListener("load", (event) => {
    const mobileMenu = document.querySelector('.mobileMenu');
    const mobileMenuToggle = document.getElementById("js-toggleNavigation");
    const overlay = document.getElementById("overlay");
    const IsTouchDevice = isTouchDevice();
    const stickyHeaderArea = document.querySelector('.headerMain');

    let breakPointSM = 1024;
    let sendFavoriteByJS = false;
    let sendItemToBasketByJS = false;
    let updateBasketByJS = false;

    if (typeof GLOBALS!== "undefined") {
        breakPointSM = GLOBALS.gridBreakpoints.sm;
        sendFavoriteByJS = GLOBALS.sendFavoriteByJS;
        sendItemToBasketByJS = GLOBALS.sendItemToBasketByJS;
        updateBasketByJS = GLOBALS.updateBasketByJS;
    }

    if (mobileMenu && mobileMenuToggle && overlay) {

        buildMobileMenu(mobileMenu);

        mobileMenuToggle.addEventListener("click", function () {
            if (mobileMenu.classList.contains("is-open")) {
                hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            } else {
                showMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            }
        });

        overlay.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            for (const filterbox of document.querySelectorAll('.filterBox')) {
                closeFilterBox(filterbox);
            }
        });
    }

    initTrustbars();

    initFilter();

    initActionClicks();

    initFormSubmitClicks();

    initFormSubmitChanges();

    trimInputValues();

    focusInputGroups();

    initInputBody();

    initPhoneCountryFields();

    if (window.outerWidth < breakPointSM) {
        for (const parent of document.querySelectorAll('.navgroup > ul > li')) {
            getChildrenClassForNestedItems(parent);
        }
    }

    if (sendFavoriteByJS) {
        triggerFavoritesBtns();
    }

    if (sendItemToBasketByJS) {
        triggerBasketBtns();
    }

    if (updateBasketByJS) {
        triggerUpdateBasketView();
    }

    triggerModal();
    excludeModal();
    triggerOpenLinkInModal();
    triggerConfirmModalLink();
    triggerOpenTextInModal();

    initQuantitySpinners();

    initToggleSlide();

    if (!IsTouchDevice) {
        for (const el of document.querySelectorAll('.itembox,.iconbarItem')) {
            hoverintent(el);
        }
    }
    for (const el of document.querySelectorAll('.js-mainNavigation li')) {
        hoverintent(el);
    }

    initSlideshows();

    initImageGallery();

    initScrollbars();

    initSlidecontents();

    initItemlistSlider();

    initCustomSelects();

    initRangeslider(document,function (e){
        if(e.slider.closest(".js-customSelect")){
            updateCustomSelectRangeFilterAction(e.slider.closest(".js-customSelect"),e.value);
        }
    });

    // Tooltip, when necessary
    // import {Tooltip} from "../../../default/global/js/tooltip-custom";

    //var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
    //var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    //    return new Tooltip(tooltipTriggerEl);
    //});

    initSearchItems(document.querySelectorAll('.js-searchInput'));

    initFlashmessages();

    const getOffsetTopJumpmarks = () => {
        let offset = 0;
        if (stickyHeaderArea) {
            offset = stickyHeaderArea.clientHeight;
        }

        if (typeof GLOBALS!== "undefined") {
            if(GLOBALS.offsetTopJumpmarks){
                offset += GLOBALS.offsetTopJumpmarks;
            }
        }
        return offset;
    };

    initJumpmarks(getOffsetTopJumpmarks);

    for (const item of document.querySelectorAll(".js-openGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item);
        });
    }

    let offsetTopStickyBox = 30;
    if (stickyHeaderArea) {
        offsetTopStickyBox += stickyHeaderArea.clientHeight;
    }

    for (const pinBox of document.querySelectorAll(".js-stickyBox")) {
        stickyBox(pinBox, {
            offsetTop: offsetTopStickyBox
        });
    }
    lottieLoader();

    addLoadingClassAfterSubmit();
    initPasswordFields();

    addTableWrapper();

    initDcOrder();

    initShowMoreRatings();

    initInputMaskDate();

    initRecaptchaForms();

    initAjaxCollectionFilter();

    initDatepicker();

    initHistorySlider();

    initContentTabs();

    initFlyout();

    initAjaxFormApi();

    initScrollActivate();

    initHighlightEditors();

    maxHeightContent();

    initDirectOrder();

    updateItemlistStickyOrderBarCount();

    langSwitchByHrefLang();
    switchImgOnHover();

    initFunding();

    initNews();

    initFixedContact();

    initLoginTabs();

    initIOSCursorFix();

    // Footer collapse functionality for mobile
    const footerHeadlines = document.querySelectorAll('.footerMenu .footerHeadline');
    footerHeadlines.forEach(headline => {
        headline.addEventListener('click', function() {
            if (window.innerWidth < 1024) {
                const navElement = this.nextElementSibling;
                if (navElement && navElement.classList.contains('dlrg--collapse-mobile')) {
                    const isOpen = this.classList.contains('is-open');
                    const dropdowns = document.querySelectorAll('.dlrg--collapse-mobile');
                    for (const dropdown of dropdowns) {
                        dropdown.classList.remove('is-open');
                    }
                    for(const footerHeadline of footerHeadlines){
                        footerHeadline.classList.remove('is-open');
                    }
                    if (!isOpen) {
                        this.classList.add('is-open');
                        navElement.classList.add('is-open');
                    }
                }
            }
        });
    });

    window.main = {
        hideAllCustomSelect: function (){
            hideAllCustomSelect();
        },
        hideCustomSelect: function (select){
            hideCustomSelect(select);
        }
    };

    showAccountIcon();
});

function showAccountIcon() {
    const accountIcon = document.querySelector('.headerAccount .iconbarItem--login .icon');
    if(accountIcon) {
        const resizeObserver = new ResizeObserver(() => {

            if (window.innerWidth < GLOBALS.gridBreakpoints.md && !GLOBALS.config.userIsLoggedIn) {
                accountIcon.classList.add('icon-user-plus');
                accountIcon.classList.remove('icon-user');
            } else {
                accountIcon.classList.add('icon-user');
                accountIcon.classList.remove('icon-user-plus');
            }
        });

        resizeObserver.observe(document.body);
    }

}